"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isChainflexImport = exports.ChainflexImportSchema = void 0;
const tslib_1 = require("tslib");
const echain_shared_i18n_1 = require("@igus/echain-shared-i18n");
const echain_prisma_client_1 = require("@igus/echain-prisma-client");
const zod_1 = require("zod");
const AnglePerLengthUnitSchema_1 = tslib_1.__importDefault(require("../../generated/zod/inputTypeSchemas/AnglePerLengthUnitSchema"));
const WeightPerLengthUnitSchema_1 = tslib_1.__importDefault(require("../../generated/zod/inputTypeSchemas/WeightPerLengthUnitSchema"));
const ChainflexSchema_1 = require("../../generated/zod/modelSchema/ChainflexSchema");
const ArticleType_1 = require("../ArticleType");
const UvBestaendigkeit_1 = require("../UvBestaendigkeit");
exports.ChainflexImportSchema = ChainflexSchema_1.ChainflexSchema.extend({
    articleType: zod_1.z.custom((a) => a === ArticleType_1.ArticleType.leitung, { message: 'invalid ArticleType' }),
    // JSON fields => LocalizedText's
    artNr: zod_1.z.custom(echain_shared_i18n_1.isLocalizedText, { message: 'invalid LocalizedText' }),
    nominalCrossSection: zod_1.z
        .custom(echain_shared_i18n_1.isLocalizedText, { message: 'invalid LocalizedText' })
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    crossSection: zod_1.z.custom(echain_shared_i18n_1.isLocalizedText, { message: 'invalid LocalizedText' }),
    busSystem: zod_1.z
        .custom(echain_shared_i18n_1.isLocalizedText, { message: 'invalid LocalizedText' })
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    categories: zod_1.z.nativeEnum(echain_prisma_client_1.ChainflexCategory).array().nonempty(),
    copperWeightUnit: WeightPerLengthUnitSchema_1.default.nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    torsionAngleUnit: AnglePerLengthUnitSchema_1.default.nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    akeneoUuid: zod_1.z
        .string()
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    numberOfCoresCalculated: zod_1.z
        .number()
        .int()
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    copperWeight: zod_1.z
        .number()
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    torsionAngle: zod_1.z
        .number()
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    uvResistant: zod_1.z.custom(UvBestaendigkeit_1.isUvBestaendigkeit, { message: 'invalid UvBestaendigkeit' }),
});
const isChainflexImport = (whatever) => {
    var _a;
    return (_a = exports.ChainflexImportSchema.safeParse(whatever)) === null || _a === void 0 ? void 0 : _a.success;
};
exports.isChainflexImport = isChainflexImport;
//# sourceMappingURL=ChainflexImport.js.map